export default __webpack_public_path__ + "static/media/PartOfOurStoryLogo3.3b4e199e.webp";